import { useField$Simple } from "@/modules/form-field/hooks/useField$Simple";

type Value = "on-demand-minting" | "reservation-based-minting";

export type MintingMethod = Value;

export const useFieldMintingMethod = useField$Simple.withConfig<Value>({
  getInitialDraft: (params) => params.initialValue || "on-demand-minting",
  validate: () => undefined,
});
